import './bootstrap';
import Vue from "vue"
import router from './router.js'
import store from './store/index'
import App from './App.vue'
import { setHeaderToken } from './utils/auth';

Vue.config.productionTip = false

const token = localStorage.getItem('token');

if (token) {
    setHeaderToken(token)
}

store.dispatch('get_user', token)
.then(() => {
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
}).catch((error) => {
    console.error(error);
})

